import React, { useEffect, useState } from "react";
import { I, T } from "services/lang/LanguageService";
import "../../dashboard-styles/Dashboard.scss";
import useIsMobile from "hooks/useIsMobile";
import { IDashboardComponent } from "api/model/dashboard/DashboardComponent";
import ComponentContextWrapper from "../context/ComponentContextWrapper";

interface IDashboardComponentCardProps {
  component: IDashboardComponent;
  tabId: number;
  groupId: string;
}

const DashboardComponentCard = ({ component, tabId, groupId }: IDashboardComponentCardProps) => {
  const isMobile = useIsMobile();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(
    (component.collapsable && component.defaultCollapsed) ?? false
  );

  const toggleCollapse = () => {
    setIsCollapsed(prev => !prev);
  };

  useEffect(() => {
    setIsCollapsed((component.collapsable && component.defaultCollapsed) ?? false);
  }, [component.collapsable, component.defaultCollapsed]);
  return (
    <div className="easas-dashboard-component">
      {component.collapsable && (
        <div className="flex flex-row justify-content-between">
          <i
            className={`pi ${isCollapsed ? "pi-plus" : "pi-minus"}`}
            onClick={toggleCollapse}
            aria-label={isCollapsed ? T("action.expand") : T("action.collapse")}
            style={{ fontSize: "1.5rem" }}
          />
          {isCollapsed && (
            <div className="flex align-items-start">
              {component.title && !isMobile && <h4>{I(component.title)}</h4>}
              {component.title && isMobile && <h6>{I(component.title)}</h6>}
            </div>
          )}
          <div />
        </div>
      )}
      {component.type !== "SEPARATOR" && !isCollapsed && (
        <div className="easas-dashboard-component-content">
          {component.title && !isMobile && <h4>{I(component.title)}</h4>}
          {component.title && isMobile && <h6>{I(component.title)}</h6>}
          <ComponentContextWrapper component={component} tabId={tabId} groupId={groupId} />
        </div>
      )}
    </div>
  );
};

export default DashboardComponentCard;
